import { createContext, useContext, useEffect, useState } from "react";
import { myWallet } from "../service/mywallet";

const WalletContext = createContext();
const EMPTY_WALLET = {
  wallet_id: null,
  balance: 0,
};

const parseBalance = (value) => {
  const parsedValue = Number(value);
  return Number.isNaN(parsedValue) ? 0 : parsedValue;
};

const normalizeWalletData = (wallet) => ({
  ...EMPTY_WALLET,
  ...wallet,
  wallet_id: wallet?.wallet_id ?? wallet?.id ?? null,
  balance: parseBalance(
    wallet?.balance ??
      wallet?.coins ??
      wallet?.coin_balance ??
      wallet?.wallet_balance ??
      wallet?.available_balance ??
      wallet?.total_coins
  ),
});

export const WalletProvider = ({ children }) => {
  const [walletData, setWalletData] = useState(EMPTY_WALLET);

  const [loading, setLoading] = useState(true);

  const resetWallet = () => {
    setWalletData(EMPTY_WALLET);
  };

  const fetchWallet = async (tokenOverride) => {
    const token = tokenOverride || localStorage.getItem("token");

    if (!token) {
      resetWallet();
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const res = await myWallet(token);
      const isSuccess = Boolean(res?.data?.status ?? res?.data?.success);
      const walletPayload =
        res?.data?.data?.wallet ?? res?.data?.wallet ?? res?.data?.data;

      if (isSuccess && walletPayload) {
        setWalletData(normalizeWalletData(walletPayload));
      } else {
        resetWallet();
      }
    } catch (err) {
      console.log(err);
      resetWallet();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const syncWalletFromSession = () => {
      const token = localStorage.getItem("token");

      if (token) {
        fetchWallet(token);
      } else {
        resetWallet();
        setLoading(false);
      }
    };

    syncWalletFromSession();
    window.addEventListener("storage", syncWalletFromSession);

    return () => {
      window.removeEventListener("storage", syncWalletFromSession);
    };
  }, []);


  return (
    <WalletContext.Provider
      value={{
        walletData,
        setWalletData,
        fetchWallet,
        loading,
      }}
    >
      {children}
    </WalletContext.Provider>
  );
};

export const useWallet = () => useContext(WalletContext);
